import { API_ROUTES } from "./constants";
import axiosInstance from "./axiosInstance";

// Create a new admin user
export const adminCreate = async (userData) => {
  try {
    const response = await axiosInstance.post(API_ROUTES.ADMIN.CREATE, userData);
    return response.data;
  } catch (error) {
    console.error('Error creating admin user:', error);
    throw error;
  }
};

// Update an existing admin user
export const adminUpdate = async (adminId, userData) => {
  try {
    const response = await axiosInstance.patch(`${API_ROUTES.ADMIN.UPDATE}/${adminId}`, userData, 
      { headers: userData instanceof FormData ? { "Content-Type": "multipart/form-data" } : {} });
    return response.data;
  } catch (error) {
    console.error('Error updating admin user:', error);
    throw error;
  }
};

export const adminDelete = async (adminUserIds) => {
  try {
      const response = await axiosInstance.delete(API_ROUTES.ADMIN.DELETE, {
        data: {
          ids: adminUserIds // array of numbers, e.g., [1, 2, 3]
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error deleting user:', error);
      throw error;
    }
};

// Get admin user details
export const adminGet = async (adminId) => {
  try {
    const response = await axiosInstance.get(`${API_ROUTES.ADMIN.GET}/${adminId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching admin user:', error);
    throw error;
  }
};

// Get all admin users
export const adminGetAll = async (query = {}) => {
  try {
    const response = await axiosInstance.get(API_ROUTES.ADMIN.GET_ALL, { params: query });
    return response.data;
  } catch (error) {
    console.error('Error fetching all admin users:', error);
    throw error;
  }
};

// Get all sales person users
export const getSalePersons = async (query = {}) => {
  try {
    const response = await axiosInstance.get(API_ROUTES.ADMIN.GET_ALL_SALES_PERSON, {
      params: { ...query, role: query.role || 'Sale Person' }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching sales persons:', error);
    throw error;
  }
};
